import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import MediaQuery from 'react-responsive'
import BB8 from './BB8'
import Teach from './Teach'

const ResponsiveTeach = () => (
  <div>
    <MediaQuery minDeviceWidth={768}>
      <Teach />
    </MediaQuery>
    <MediaQuery maxDeviceWidth={767}>
      <BB8 />
    </MediaQuery>
  </div>
)

export default ResponsiveTeach
